/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Selfhost_S2Inputs */

const en_fc_online_selfhost_s2 = /** @type {(inputs: Fc_Online_Selfhost_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inside the folder, start any static server.`)
};

/**
* | output |
* | --- |
* | "Inside the folder, start any static server." |
*
* @param {Fc_Online_Selfhost_S2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_selfhost_s2 = /** @type {((inputs?: Fc_Online_Selfhost_S2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Selfhost_S2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_selfhost_s2(inputs)
});
export { fc_online_selfhost_s2 as "fc.online.selfhost.s2" }